<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.name')" type="text" v-model="client.name"></CInput>
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.address')" type="text" v-model="client.address"></CInput>
            </div>
          </div>
          
          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.address2')" type="text" v-model="client.address2"></CInput>
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.phone')" type="text" v-model="client.phone"></CInput>
            </div>
          </div>
          
          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.phone2')" type="text" v-model="client.phone2"></CInput>
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.state')" type="text" v-model="client.state"></CInput>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.city')" type="text" v-model="client.city"></CInput>
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.zipcode')" type="text" v-model="client.zipcode"></CInput>
            </div>
          </div>
          
          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.order_frequency')" type="text" v-model="client.order_frequency"></CInput>
            </div>
            <div class="col-6">
              <div class="form-group" role="group">
                <label>{{ $t('fields.is_active') }}</label>
                <div>
                  <CBadge 
                    :color="client.status_class">
                    {{ client.status ? $t('fields.active') : $t('fields.inactive') }}
                  </CBadge>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.payment_frequency')" type="text" v-model="client.frequency_payment"></CInput>
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.credit_frequency')" type="text" v-model="client.frequency_credit"></CInput>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.client_type')" type="text" v-model="client.client_type"></CInput>
            </div>
            <div class="col-6">
              <div class="form-group" role="group">
                <label>{{ $t('fields.check_frequency') }}</label>
                <div>
                  <CBadge 
                    :color="client.status_class">
                    {{ client.frequency_active ? $t('fields.active') : $t('fields.inactive') }}
                  </CBadge>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <CInput readonly label="Water Dispenser" type="text" v-model="client.water_dispenser"></CInput>
            </div>
            <div class="col-6">
              <CInput readonly label="Existing Bottles" type="text" v-model="client.existing_bottles"></CInput>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="form-group" role="group">
                <label>Own</label>
                <div>
                  <CBadge 
                    :color="client.status_class">
                    {{ client.own ? $t('fields.active') : $t('fields.inactive') }}
                  </CBadge>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group" role="group">
                <label>Rented</label>
                <div>
                  <CBadge 
                    :color="client.status_class">
                    {{ client.rented ? $t('fields.active') : $t('fields.inactive') }}
                  </CBadge>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="client.own">
            <div class="col-6">
                <CInput readonly label="Date" type="date" v-model="client.own_date"></CInput>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <CTextarea readonly :label="$t('fields.comment')" v-model="client.comment"></CTextarea>
            </div>
          </div>
          <CButton v-if="permissions.clients.edit" color="success" @click="editClient">
            <CIcon :content="$options.editIcon" /> {{ $t('button.edit') }}
          </CButton>
          <CButton color="primary" @click="goBack">
            <CIcon :content="$options.backIcon" /> {{ $t('button.back') }}
          </CButton>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="12" lg="6">
        <CCard>
          <CCardHeader>
            {{ $t('history') }}
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="mb-0 table-outline"
              :items="client.orders"
              :fields="tableFields"
              head-color="light"
              hover
              no-sorting
            >
              <td slot="orderdate" slot-scope="{item}">
                <div>{{ item.orderdate }}</div>
              </td>
              <td slot="payment" slot-scope="{item}">
                <CBadge :color="item.payment_class">{{item.payment}}</CBadge>
              </td>
              <td slot="pay" slot-scope="{item}">
                <CBadge :color="item.payment_class">{{item.pay}}</CBadge>
              </td>
              <td slot="amount" slot-scope="{item}">
                <div>${{ item.amount | toCurrency }}</div>
              </td>
              <template #options="{item}">
                <td>
                  <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" @click="openOptions" type="button" data-toggle="dropdown">
                      {{ $t('button.options') }}
                    </button>
                    <div class="dropdown-menu">
                      <button v-if="permissions.orders.read" class="dropdown-item" type="button" @click="showOrder(item.id)">{{ $t('button.details') }}</button>
                      <button v-if="permissions.orders.edit" class="dropdown-item" type="button" @click="editOrder(item.id)">{{ $t('button.edit') }}</button>
                      <button v-if="permissions.orders.delete" class="dropdown-item" type="button" @click="deleteOrder(item.id)">{{ $t('button.delete') }}</button>
                    </div>
                  </div>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import Vue from "vue";
import list from '../../mixins/list';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPencil, cilArrowLeft } from '@coreui/icons';

Vue.filter('toCurrency', function (value) {
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
});

export default {
  name: 'Client',
  mixins: [list, localeMixin],
  editIcon: cilPencil,
  backIcon: cilArrowLeft,
  data() {
    return {
      client: '',
      tableFields: [
        { key: 'orderdate', label: i18n.t('fields.order_date') },
        { key: 'payment', label: i18n.t('fields.payment_type') },
        { key: 'pay', label: i18n.t('pay') },
        { key: 'quantity', label: i18n.t('fields.quantity') },
        { key: 'amount', label: i18n.t('fields.amount') },
        {
          key: 'options',
          label: i18n.t('button.options'),
          sorter: false,
          filter: false
        }
      ],
    }
  },
  watch: {
      '$route.params': {
          handler(newValue) {
              const clientID = newValue.id;
              this.getClient(clientID);
          }
      }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    })
  },
  mounted() {
    this.getClient(this.$route.params.id);
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Clients" });
    },
    editClient() {
      const id = this.$route.params.id;
      this.$router.push({ name: 'EditClient', params: {id} });
    },
    color (value) {
      // TODO: Check if this is working here.
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    },
    getClient(id) {
      axios.get('/api/clients/' + id + '?token=' + localStorage.getItem("api_token"))
      .then(response => {
        this.client = response.data;
        this.client.status = Number(this.client.status);
        this.client.status_class = this.client.active ? "primary" : "secondary";
        this.client.water_dispenser = this.client.water_dispenser ? "Yes" : "No";
      }).catch(error => {
        console.log(error);
      });
    },
    showOrder(id) {
      this.$router.push({ name: 'Order', params: {id} });
    },
    editOrder(id) {
      this.$router.push({ name: 'EditOrder', params: {id} });
    },
    deleteOrder(id) {
      this.$swal({
        title: 'Delete Order',
        text: 'Are you sure you want to delete this order?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(result => {
        if (result.value) {
          // do delete request
          axios.delete('/api/orders/'+ id + '?token=' + localStorage.getItem("api_token"))
          .then(response => {
            this.$swal(
              'Deleted!',
              'Order has been deleted.',
              'success'
              );
              this.getClients();
          }).catch(error => {
            console.log(error);
            // TODO: check http code and message.
            this.$router.push({ path: '/login' });
          });
        }
      });
    }
  }
}


</script>

<style scoped>
.dropdown {
  display: inline-block;
}
.dropdown-menu {
  left: auto !important;
  right: 0;
}
.dropdown-menu.top {
  top: auto !important;
  bottom: 100%;
  margin-bottom: 5px;
}
.table-dropdown-fix tr:nth-last-child(-n+2) .dropdown-menu {
  top: auto !important;
  bottom: 100%;
  margin-bottom: 5px;
}
</style>
